import axios from "axios";
import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const getManagerDashboard = async (id) => {
  const response = await axios.get(routes.inviteflowManager(id), AXIOS_DEFAULT_CONFIG);
  return response;
};

export default getManagerDashboard;
